const getAllConfiguratorOutputs = (data) =>
  data.reduce((acc, step) => [...acc, ...step.output], []);

export default getAllConfiguratorOutputs;
